import { saveAs } from 'file-saver';

import { PresignedFile } from '../types/pay';

/**
 * Gateway exports answer a presigned link rather than bytes. The link expires in about
 * fifteen minutes, so it is followed straight away and never persisted anywhere.
 */
export const openPresignedFile = (file: PresignedFile) => {
  if (!file?.url) return;
  window.open(file.url, '_blank', 'noopener,noreferrer');
};

export const generateFileLink = (res: any, contentType?: string) => {
  const filename = res.headers['content-disposition']?.split('filename=')[1]?.split(';')[0];
  const blob = new Blob([res.data], {
    type: contentType || res.headers['content-type'],
  });
  return { filename, blob };
};

export const generateFileLinkAndSave = (res: any, contentType?: string) => {
  const { filename, blob } = generateFileLink(res, contentType);
  saveAs(blob, filename);
};

export const generateFileLinkAndOpen = (res: any, contentType?: string) => {
  const { blob } = generateFileLink(res, contentType);
  const url = window.URL.createObjectURL(
    new Blob([blob], {
      type: 'application/pdf',
    })
  );
  if (url) window.open(url, '_blank');
};

// Anchor click instead of window.open: the link arrives after an await, so popup blockers would kill a new tab.
export const downloadFileByUrl = (url: string, fileName?: string) => {
  const link = document.createElement('a');
  link.href = url;
  if (fileName) link.download = fileName;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const generateExcelFileLink = (res: any) => {
  const filename = res.headers['content-disposition']?.split('filename=')[1]?.split(';')[0];
  saveAs(res.data, filename);
};
